<template>
  <div class="payment-footer">
    <div class="payment-footer__content">
      <div class="payment-footer__all-rights-reserved">
        © 2023 INE. All Rights Reserved. All logos, trademarks and registered trademarks are the
        property of their respective owners.
      </div>
      <div class="payment-footer__tos">
        <a
          href="https://ine.com/terms-of-service"
          class="btn btn--tertiary payment-footer__tos--link"
          target="_blank"
        >
          Terms of service
        </a>
      </div>
      <div class="payment-footer__privacy-policy">
        <a
          href="https://ine.com/privacy-policy"
          class="btn btn--tertiary payment-footer__privacy-policy--link"
          target="_blank"
        >
          Privacy policy
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentFlowFooter',
}
</script>

<style lang="scss">
.payment-footer {
  width: 100%;
  display: flex;
  align-items: center;
  background: var(--mid-gray-gradient);
  padding: 20px;
  color: var(--white);
  font-family: var(--font-regular);
  @include mobile {
    padding: 20px 50px;
    position: sticky;
    bottom: 0;
    left: 0;
  }
  @include desktop {
    position: unset;
    bottom: unset;
    left: unset;
  }
  &__content {
    width: 100%;
    max-width: 1120px;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    @include mobile {
      grid-template-columns: 74% 14% 12%;
      font-size: rem(12px);
    }
  }
  &__all-rights-reserved {
    grid-column: 1 / 3;
    margin-bottom: 10px;
    text-align: center;
    font-size: rem(14px);
    @include mobile {
      font-size: rem(12px);
      width: 75%;
      text-align: left;
      grid-column: unset;
      margin-bottom: 0;
    }
  }
  &__tos,
  &__privacy-policy {
    margin: auto;
  }
  .btn {
    &.payment-footer {
      &__tos,
      &__privacy-policy {
        &--link {
          font-size: rem(12px);
        }
      }
    }
  }
}
</style>
